import React from 'react'

import classnames from 'classnames'

import { ExpenseStatus } from 'core/domain/expenses/expenseStatus'

import Icon from 'common/components/general/Icon'

const expenseReviewIconMap = new Map<ExpenseStatus, string>([
  [ExpenseStatus.Verified, 'check-circle'],
  [ExpenseStatus.ActionRequired, 'exclamation-circle'],
  [ExpenseStatus.Ineligible, 'exclamation-circle'],
  [ExpenseStatus.AwaitingReview, 'clock'],
])

interface ExpenseReviewStatusIconProps {
  status: any
}

const ExpenseReviewIcon: React.FC<ExpenseReviewStatusIconProps> = ({ status }) => {
  const expenseReviewIconClassname = classnames(
    { 'color-green-6': status === ExpenseStatus.Verified },
    { 'color-red-6': status === ExpenseStatus.Ineligible },
    { 'color-red-6': status === ExpenseStatus.ActionRequired },
    { 'color-yellow-6': status === ExpenseStatus.AwaitingReview },
  )
  return <Icon type={`far fa-${expenseReviewIconMap.get(status)}`} fontAwesome className={expenseReviewIconClassname} />
}

export default ExpenseReviewIcon
